require('./notification.style.scss');
const { permissions } = require('../../../../constants/permissions');
const EmailNotification = require('../../../../model/EmailNotification');
const WebhookNotification = require('../../../../model/WebhookNotification');
const EMAIL_NOTIFICATION_ENDPOINT = 'eventEmails';
const WEBHOOK_NOTIFICATION_ENDPOINT = 'eventWebHooks';
const EMAIL_TAB = 'email';
const WEBHOOK_TAB = 'webhook';

class NotificationController {
    constructor($scope, $document, $element, $filter, $localStorage, $q, $timeout, contentSwitcherService, crudService, notificationService, eventsPersistence, utilsService, storageService, dialogService, validationsService, iamPersistenceService) {
        this.$element = $element;
        this.$filter = $filter;
        this.$localStorage = $localStorage;
        this.$q = $q;
        this.$scope = $scope;
        this.$document = $document;
        this.configTable();
        this.animateSwitcher = typeof this.$element[0].getBoundingClientRect === 'function';
        this.contentSwitcherService = contentSwitcherService;
        this.crudService = crudService;
        this.notificationService = notificationService;
        this.eventsPersistence = eventsPersistence;
        this.iamPersistenceService = iamPersistenceService;
        this.utilsService = utilsService;
        this.validationsService = validationsService;
        this.storageService = storageService;
        this.dialogService = dialogService;
        this.CREATE_STATE = 'create';
        this.EDIT_STATE = 'edit';
        this.MAIN_STATE = 'main';
        this.JSON_EDITOR_STATE = 'json-editor';
        this.helpId = 'notifications';
        this.animateTab = true;
        this.$timeout = $timeout;
        this.webhookJsonTemplate = '';

        this.mainTitle = this.$filter('translate')('event.dialog.notifications.title');
        this.modalTitle = this.mainTitle;
        this.modalSubTitle = null;
        this.fieldList = [];

        this.customKeyDownFn = (e) => {
            if (e.keyCode === 13) {
                if (this.state === this.JSON_EDITOR_STATE) {
                    e.stopImmediatePropagation();
                    e.stopPropagation();
                    // e.preventDefault();
                }
            }
        };
        this.$document[0].addEventListener('keydown', this.customKeyDownFn, false);
    }

    $onInit() {
        this.categories = [];
        if (this.animateSwitcher) {
            this.minInnerHeight = this.getMinHeight();
        }
        this.actionButtons = [
            {
                title: this.$filter('translate')('toolbar.default.back.label'),
                action: () => { this.onBackAction(); },
                isVisible: () => this.state !== this.MAIN_STATE,
                btnClass: 'ctx-btn-secondary',
                id: 'notification-back'
            },
            {
                title: this.$filter('translate')('common.form.default.btn.save.label'),
                type: 'submit',
                action: () => this.saveNotification(),
                isDisabled: () => this.isSaveDisabled(),
                isVisible: () => (this.currentTab === WEBHOOK_TAB && this.state === this.JSON_EDITOR_STATE) || (this.currentTab === EMAIL_TAB && (this.state === this.CREATE_STATE || this.state === this.EDIT_STATE)),
                id: 'notification-save'
            },
            {
                title: this.$filter('translate')('common.form.default.btn.next.label'),
                action: () => this.openJsonEditor(),
                isDisabled: () => (this.dialogForm && !this.dialogForm.$valid) || this.busy,
                isVisible: () => this.currentTab === WEBHOOK_TAB && (this.state === this.EDIT_STATE || this.state === this.CREATE_STATE),
                id: 'notification-next'
            }
        ];
        this.initValues();

    }

    isSaveDisabled() {
        if (this.currentTab === WEBHOOK_TAB) {
            return this.invalidJson || this.busy ? true : false;
        } else {
            return (this.dialogForm && !this.dialogForm.$valid) || this.busy || this.emailsTagsActive ? true : false;
        }

    }

    onOpen() {
        this.state = this.MAIN_STATE;
        this.loadEmails(true);
        this.loadWebhooks(true);
        this.prepareValues();
    }

    openJsonEditor() {
        this.changeState(this.JSON_EDITOR_STATE);
        this.prevState = this.state;
    }

    onBackAction() {
        if (this.animateSwitcher) {
            this.contentSwitcherService.removeAutoHeight(this.$element.find('.ctx-content-switcher')).then(() => {
                this.onModalBack();
            });
        } else {
            this.onModalBack();
        }
    }

    insertTextOnCursorPosition(text) {
        this.editor.session.insert(this.editor.getCursorPosition(), text);
    }

    onModalClose() {
        this.prepareValues();
    }

    onModalBack() {
        if (this.currentTab === WEBHOOK_TAB) {
            if (this.state === this.EDIT_STATE || this.state === this.CREATE_STATE) {
                this.state = this.MAIN_STATE;
                this.modalTitle = this.mainTitle;
                this.modalSubTitle = null;
                this.helpId = 'notifications';
                return { preventDefault: true };
            } else {
                this.state = this.prevState;
                this.modalTitle = this.mainTitle;
                this.modalSubTitle = (' » ') + (this.state === this.CREATE_STATE ? this.$filter('translate')('event.dialog.notifications.new.title') : this.$filter('translate')('event.dialog.notifications.edit.title') + ' ' + this.notification.name);
            }
        } else
            if (this.state !== this.MAIN_STATE) {
                this.state = this.MAIN_STATE;
                this.modalTitle = this.mainTitle;
                this.modalSubTitle = null;
                this.helpId = 'notifications';
                this.editEmptySecret = false;
                return { preventDefault: true };
            }
    }

    onTitleClick() {
        this.changeState(this.MAIN_STATE);
    }

    prepareValues() {
        this.emailsTagsActive = false;
        this.selectedEmailNotifications = [];
        this.notification = null;
        this.state = this.MAIN_STATE;
        this.prevState = undefined;
        this.busy = false;
        this.selectedSeverities = null;
        this.selectedCategories = null;
        this.editEmptySecret = false;
        if (this.reload) {
            this.reload = false;
        }
        this.currentTab = EMAIL_TAB;
        this.defaultTab = 1;
        if (this.emailNotificationsTableState) {
            this.emailNotificationsTableState.searchBy = '';
        }
    }

    initValues() {
        this.categories = [];
        this.selectedSeverities = null;
        this.selectedCategories = null;
        this.busy = this.eventsPersistence.getAllEventsCategories().then(categories => {
            categories.forEach(category => {
                this.categories.push({ label: this.utilsService.enumToNiceString(category), value: category });
            });
        }).finally(() => {
            this.allCategories = this.categories;
            this.busy = false;
        });
        this.severities = [
            { label: 'Info', value: 'INFO' },
            { label: 'Warning', value: 'WARNING' },
            { label: 'Error', value: 'ERROR' }
        ];

        this.aceOptions = {
            mode: 'json',
            onLoad: (editor, session, ace) => {
                this.invalidJson = false;
                this.editor = ace.edit("aceEditor");
                editor.setShowPrintMargin(false);
                editor.getSession().on("changeAnnotation", () => {
                    var annot = editor.getSession().getAnnotations();
                    if (annot.length > 0) {
                        this.invalidJson = true;
                    } else {
                        this.invalidJson = false;
                    }
                });
            },
            require: ['ace/ext/language_tools'],
            advanced: {
                enableSnippets: true,
                enableBasicAutocompletion: true,
                enableLiveAutocompletion: true
            }
        };
    }

    setValuesOnEdit() {
        this.selectedCategories = [];
        this.selectedSeverities = [];
        this.notification.categories.forEach((elem) => {
            this.categories.forEach((el) => {
                if (el.value === elem) {
                    if (typeof this.selectedCategories === 'undefined') this.selectedCategories = [];
                    el.selected = true;
                    this.selectedCategories.push(el);
                } else {
                    el.selected = false;
                }
            });
        });
        this.notification.severities.forEach((elem) => {
            this.severities.forEach((el) => {
                if (el.value === elem) {
                    if (typeof this.selectedSeverities === 'undefined') this.selectedSeverities = [];
                    el.selected = true;
                    this.selectedSeverities.push(el);
                } else {
                    el.selected = false;
                }
            });
        });

        if (!this.notification.secretSet) {
            this.editEmptySecret = true;
        } else {
            this.editEmptySecret = false;
        }
    }

    onTabChange(previous, active) {
        return this.$q((resolve) => {
            this.currentTab = (active === 'tab0' ? EMAIL_TAB : WEBHOOK_TAB);
            this.defaultTab = (active === 'tab0' ? 1 : 2);
            resolve();
        });
    }

    newNotificationItem() {
        if (this.currentTab === EMAIL_TAB) {
            this.notification = new EmailNotification();
        }
        else {
            this.fieldList = [];
            this.enableChangeSecret = true;
            this.eventsPersistence.getWebHookJsonFormat().then((res) => {
                this.notification.template, this.webhookJsonTemplate = JSON.stringify(JSON.parse(res.template), null, 4);
                Object.keys(res.fields).forEach((field) => {
                    this.fieldList.push({
                        title: this.$filter('translate')('event.dialog.webhookNotifications.editor.field.' + field),
                        type: 'submit',
                        action: () => this.insertTextOnCursorPosition(res.fields[field]),
                        id: field
                    });
                });
            });
            this.notification = new WebhookNotification();
        }
        this.changeState(this.CREATE_STATE);
        this.initValues();
    }

    async editNotificationItem() {
        if (this.currentTab === EMAIL_TAB) {
            this.notification = EmailNotification.fromRaw(await this.eventsPersistence.getEmailNotificationDetails(this.selectedEmailNotifications[0].uuid));
        }
        else {
            this.fieldList = [];

            this.enableChangeSecret = false;
            this.eventsPersistence.getWebHookJsonFormat().then((res) => {
                Object.keys(res.fields).forEach((field) => {
                    this.fieldList.push({
                        title: this.$filter('translate')('event.dialog.webhookNotifications.editor.field.' + field),
                        type: 'submit',
                        action: () => this.insertTextOnCursorPosition(res.fields[field]),
                        id: field
                    });
                });
            });
            this.notification = WebhookNotification.fromRaw(await this.eventsPersistence.getWebHookNotificationDetails(this.selectedWebhookNotifications[0].uuid));
            this.notification.template,
                this.webhookJsonTemplate = this.notification.template === ""
                    ? ""
                    : JSON.stringify(JSON.parse(this.notification.template), null, 4);
        }
        this.setValuesOnEdit();

        if (this.notification) this.changeState(this.EDIT_STATE);
    }

    deleteNotificationItem() {
        this.dialogService.showYesNo(this.$filter('translate')('event.dialog.notifications.deleteDialog.text', { type: this.currentTab, title: this.currentTab === EMAIL_TAB ? this.selectedEmailNotifications[0].subject : this.selectedWebhookNotifications[0].name }), this.$filter('translate')('event.dialog.notifications.deleteDialog.title', { type: this.currentTab }), null, 'delete-email-notification')
            .then(result => {
                if (!result) return;
                this.reload = true;
                let url = this.currentTab === EMAIL_TAB ? EMAIL_NOTIFICATION_ENDPOINT : WEBHOOK_NOTIFICATION_ENDPOINT;
                let uuid = this.currentTab === EMAIL_TAB ? this.selectedEmailNotifications[0].uuid : this.selectedWebhookNotifications[0].uuid;
                this.busy = this.crudService.del(url, uuid).then(res => {
                    this.notificationService.pop(res.data.message);
                    if (this.currentTab === EMAIL_TAB) {
                        this.loadEmails();
                    }
                    else {
                        this.loadWebhooks();
                    }
                    this.selectedEmailNotifications = [];
                    this.selectedWebhookNotifications = [];
                }).finally(() => { this.busy = false; });
            });

    }

    loadEmails(firstPage, animate, onSave, email) {
        this.getEmailNotificationItem(firstPage).then(notifications => {
            if (notifications) {
                this.emailNotifications = notifications.map((notification) => EmailNotification.fromRaw(notification));
                if (this.animateSwitcher && animate) {
                    this.contentSwitcherService.removeAutoHeight(this.$element.find('.ctx-content-switcher')).then(() => {
                        this.minInnerHeight = !this.minInnerHeight ? this.getMinHeight() : this.minInnerHeight;
                        this.contentSwitcherService.customAnimation(this.$element, this.minInnerHeight);
                    });
                }
                if (onSave) {
                    this.selectedEmailNotifications[0] = notifications.filter(notification => email.subject === notification.subject)[0];
                }
            }
        });
    }

    loadWebhooks(firstPage, animate, onSave, webhook) {
        this.getWebhookNotificationItem(firstPage).then(notifications => {
            this.webhookNotifications = notifications.map((notification) => WebhookNotification.fromRaw(notification));
            if (this.animateSwitcher && animate) {
                this.contentSwitcherService.removeAutoHeight(this.$element.find('.ctx-content-switcher')).then(() => {
                    this.minInnerHeight = !this.minInnerHeight ? this.getMinHeight() : this.minInnerHeight;
                    this.contentSwitcherService.customAnimation(this.$element, this.minInnerHeight);
                });
            }
            if (onSave) {
                this.selectedWebhookNotifications[0] = notifications.filter(notification => webhook.name === notification.name)[0];
            }
        });
    }

    getEmailNotificationItem(firstPage) {
        if (!this.hasEmailListingPermissions()) {
            return this.$q((resolve) => { resolve([]); });
        }

        if (firstPage && this.emailNotificationsTableState) {
            this.emailNotificationsTableState.page = 1;
        }

        return this.crudService.getPaged(EMAIL_NOTIFICATION_ENDPOINT, this.emailNotificationsTableState, EmailNotification.getSearchKey(), null, null, 10).then(resp => {
            this.emailNotificationsTableState = resp.data.tableState;
            return resp.data.entities;
        });
    }

    getWebhookNotificationItem(firstPage) {
        if (!this.hasWebhookListingPermissions()) {
            return this.$q((resolve) => { resolve([]); });
        }

        if (firstPage && this.webhookNotificationsTableState) {
            this.webhookNotificationsTableState.page = 1;
        }

        return this.crudService.getPaged(WEBHOOK_NOTIFICATION_ENDPOINT, this.webhookNotificationsTableState, WebhookNotification.getSearchKey(), null, null, 10).then(resp => {
            this.webhookNotificationsTableState = resp.data.tableState;
            return resp.data.entities;
        });
    }

    onChangeSecret() {
        if (this.enableChangeSecret) {
            this.editEmptySecret = false;
            if (!this.tempSecret) {
                this.tempSecret = this.notification.secret;
            }
            this.notification.secret = '';

            this.$timeout(() => {
                this.resetSecret = true;
            }, 0);
        } else {
            this.editEmptySecret = true;
            this.tempSecret ? this.notification.secret = '**************************' : null;
            this.resetSecret = false;
        }
    };

    saveNotification() {
        let rest = this.currentTab === EMAIL_TAB ? EMAIL_NOTIFICATION_ENDPOINT : WEBHOOK_NOTIFICATION_ENDPOINT;
        if (this.state === this.EDIT_STATE || this.prevState === this.EDIT_STATE) {
            rest += '/' + (this.currentTab === EMAIL_TAB ? encodeURI(this.selectedEmailNotifications[0].uuid) : encodeURI(this.selectedWebhookNotifications[0].uuid));
        }

        if (this.currentTab === WEBHOOK_TAB) {
            this.notification.template = this.webhookJsonTemplate;
        } else {
            delete this.notification.template;
        }

        if (this.currentTab !== EMAIL_TAB && !this.enableChangeSecret) {
            delete this.notification.secret;
        }


        if (this.selectedCategories.length > 0) {
            this.notification.categories = [];
            this.selectedCategories.forEach(item => {
                if (this.notification.categories.indexOf(item.value) === -1) {
                    this.notification.categories.push(item.value);
                }
            });
        }
        if (this.selectedSeverities.length > 0) {
            this.notification.severities = [];
            this.selectedSeverities.forEach(item => {
                if (this.notification.severities.indexOf(item.value) === -1) {
                    this.notification.severities.push(item.value);
                }
            });
        }
        if (this.state === this.CREATE_STATE || this.prevState === this.CREATE_STATE) {
            this.notification.subscriptionId = this.notification.subscriptionId = this.storageService.getSubscription().uuid;
        }
        this.busy = this.crudService[this.state === this.CREATE_STATE || this.prevState === this.CREATE_STATE ? 'post' : 'put'](rest, this.notification.toRaw())
            .then(resp => {
                if (this.currentTab === EMAIL_TAB) {
                    this.loadEmails(null, null, true, this.notification);
                }
                else {
                    this.loadWebhooks(null, null, true, this.notification);
                }
                this.reload = this.reload || (this.state === this.EDIT_STATE || this.prevState === this.EDIT_STATE);
                this.notificationService.pop(resp.data.message);

                this.changeState(this.MAIN_STATE);
                this.prevState = undefined;
            }, err => {
                if (err.status !== 415) {
                    this.changeState(this.MAIN_STATE);
                    this.prevState = undefined;
                }
            })
            .finally(() => {
                this.busy = false;
            });
    }

    changeState(state) {
        if (this.animateSwitcher) {
            this.contentSwitcherService.removeAutoHeight(this.$element.find('.ctx-content-switcher')).then(() => {
                this.changeStateAction(state);
            });
        } else {
            this.changeStateAction(state);
        }
    }

    changeStateAction(state) {
        if (state === this.MAIN_STATE) {
            this.modalTitle = this.mainTitle;
            this.modalSubTitle = null;
            this.helpId = 'notifications';
            this.busy = false;
        }
        else {
            if (state === this.EDIT_STATE || state === this.CREATE_STATE) {
                this.notification.secret = this.currentTab === WEBHOOK_TAB && state === this.EDIT_STATE && this.notification.secretSet ? "**************************" : undefined;
                if (this.currentTab === EMAIL_TAB) {
                    this.helpId = 'email-notification';
                } else if (this.currentTab === WEBHOOK_TAB) {
                    this.helpId = 'webhook-notification';
                }
            }
            this.notification.template = this.currentTab === WEBHOOK_TAB ? this.notification.template : undefined;
            this.modalTitle = this.mainTitle;
            this.modalSubTitle = (' » ') + (state === this.CREATE_STATE ? this.$filter('translate')('event.dialog.notifications.new.title') : this.$filter('translate')('event.dialog.notifications.edit.title') + ' ' + (this.currentTab === EMAIL_TAB ? this.notification.subject : this.notification.name));
        }
        this.state = state;
    }

    configTable() {
        this.emailNotificationsTableConfig = [
            this.$filter('translate')('event.dialog.emailNotifications.table.header')
        ];
        this.webhookNotificationsTableConfig = [
            this.$filter('translate')('event.dialog.webhookNotifications.table.header.name'),
            this.$filter('translate')('event.dialog.webhookNotifications.table.header.description')
        ];
    }

    setGrid(grid) {
        this.grid = grid;
        this.ctxGridStyleConfig = {
            multiselect: false,
            columnsWidthMapInPct: []
        };
        if (this.currentTab !== WEBHOOK_TAB) {
            this.ctxGridStyleConfig.columnsWidthMapInPct.push('100%');
        } else {
            this.ctxGridStyleConfig.columnsWidthMapInPct.push('50%');
            this.ctxGridStyleConfig.columnsWidthMapInPct.push('50%');
        }

        this.gridColumnsStyleConfig = this.ctxGridStyleConfig;
        this.gridFlag = true;
    }

    getMinHeight() {
        const modalBody = this.$element.find('.modal-body'),
            minHeight = modalBody[0] ? modalBody.css('min-height') : null;
        return minHeight ? (parseFloat(minHeight) - parseFloat(modalBody.css('padding-top')) - parseFloat(modalBody.css('padding-bottom'))) : null;
    }

    searchCategories() {
        this.categories = this.allCategories.filter(category => category.label.toLowerCase().indexOf(this.categoriesSearch.searchBy.toLowerCase()) !== -1);
    }

    isCreateEmailNtfcDisabled() {
        return !this.hasCreateEmailNtfcPermissions();
    }

    isUpdateEmailNtfcDisabled() {
        return !this.hasUpdateEmailNtfcPermissions() || !this.selectedEmailNotifications || !this.selectedEmailNotifications.length || this.selectedEmailNotifications.length !== 1;
    }

    isDeleteEmailNtfcDisabled() {
        return !this.hasDeleteEmailNtfcPermissions() || !this.selectedEmailNotifications || !this.selectedEmailNotifications.length || this.selectedEmailNotifications.length !== 1;
    }

    isCreateWebhookNtfcDisabled() {
        return !this.hasCreateWebhookNtfcPermissions();
    }

    isUpdateWebhookNtfcDisabled() {
        return !this.hasUpdateWebhookNtfcPermissions() || !this.selectedWebhookNotifications || !this.selectedWebhookNotifications.length || this.selectedWebhookNotifications.length !== 1;;
    }

    isDeleteWebhookNtfcDisabled() {
        return !this.hasDeleteWebhookNtfcPermissions() || !this.selectedWebhookNotifications || !this.selectedWebhookNotifications.length || this.selectedWebhookNotifications.length !== 1;;
    }

    hasCreateEmailNtfcPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.EMAIL_NOTIFICATIONS_CREATE);
    }

    hasUpdateEmailNtfcPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.EMAIL_NOTIFICATIONS_UPDATE);
    }

    hasDeleteEmailNtfcPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.EMAIL_NOTIFICATIONS_DELETE);
    }

    hasEmailListingPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.EMAIL_NOTIFICATIONS_LISTING);
    }

    hasCreateWebhookNtfcPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.WEBHOOK_NOTIFICATIONS_CREATE);
    }

    hasUpdateWebhookNtfcPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.WEBHOOK_NOTIFICATIONS_UPDATE);
    }

    hasDeleteWebhookNtfcPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.WEBHOOK_NOTIFICATIONS_DELETE);
    }

    hasWebhookListingPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.WEBHOOK_NOTIFICATIONS_LISTING);
    }
}

NotificationController.$inject = ['$scope', '$document', '$element', '$filter', '$localStorage', '$q', '$timeout', 'contentSwitcherService', 'crudService', 'notificationService', 'eventsPersistence', 'utilsService', 'storageService', 'dialogService', 'validationsService', 'iamPersistenceService'];

const notificationComponent = {
    controller: NotificationController,
    template: require('./notification.template.html'),

    bindings: {
        showModal: '=',
    }
};

module.exports = notificationComponent;


// WEBPACK FOOTER //
// ./src/azurebackup/views/events/dialogs/emailNotifications/notification.component.js